<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="packingListsFiltered"
            class="elevation-0"
            :mobile-breakpoint="0"
            :loading="loading"
            fixed-header
            item-key="id"
            :items-per-page.sync="itemsPerPage"
            :footer-props="{ itemsPerPageOptions: [25, 50, 100] }"
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    class="mt-0 mx-0 pt-4 pb-0 pb-4"
                    :style="{ 'background-color': '#eeeeee' }"
                >
                    <v-col cols="12" class="d-flex mb-n3">
                        <h1 class="mr-4">PACKING LISTS</h1>
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateRangeText"
                                    label="Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    :style="{ 'max-width': '250px' }"
                                    class="pt-1"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dates" range scrollable>
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="menu = false"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    :loading="loading"
                                    @click="getPackingLists"
                                >
                                    OK
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                        <v-btn
                            color="primary"
                            class="ml-2 mt-1"
                            small
                            @click="openReportDialog"
                        >
                            REPORT
                        </v-btn>
                        <v-spacer />
                    </v-col>
                </v-row>
            </template>
            <!--HEADERS-->
            <template v-slot:[`header.code`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="search"
                    dense
                />
            </template>
            <template v-slot:[`header.workOrdersAndBoms`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="workOrderAndBomToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.createdBy`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="userToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.project`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="projectToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.remission`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="remissionToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.container`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="containerToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.notes`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="notesToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.createdOn`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="createdOnToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.requestedShipmentDate`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="requestedShipmentDateToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.scheduledFor`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="scheduledForToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.shippedOn`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="shippedOnToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.shippedBy`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="shippedByToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.completedOn`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="completedOnToFilter"
                    dense
                />
            </template>
            <!--ITEMS-->
            <template v-slot:[`item.createdBy`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">{{ item.createdByName }}</p>
                </div>
            </template>
            <template v-slot:[`item.workOrdersAndBoms`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{ item.selectedWorkOrdersAndBomsString }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.project`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{ item.projectLabel }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.createdOn`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{ item.createdOnLabel }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.shippedOn`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{ item.shippedOnLabel }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.shippedBy`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{ item.shippedByName }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.completedOn`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{ item.completedOnLabel }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.requestedShipmentDate`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{ item.requestedShipmentDate }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.scheduledFor`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{ item.scheduledFor }}
                    </p>
                </div>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
                <div class="d-flex justify-center">
                    <v-btn small icon @click="openProcessPackingList(item)">
                        <v-icon>{{
                            item.status !== 'completed'
                                ? 'mdi-pencil'
                                : 'mdi-eye'
                        }}</v-icon>
                    </v-btn>
                </div>
            </template>
        </v-data-table>
        <v-alert
            v-if="activateAlert"
            type="success"
            color="primary"
            :style="{ position: 'absolute', right: '0px', bottom: '0px' }"
        >
            <v-row no-gutters>
                <v-col cols="11">
                    <p class="my-0">{{ alertMessage }}</p>
                </v-col>
                <v-col cols="1">
                    <v-btn
                        small
                        icon
                        class="mt-n1"
                        @click="activateAlert = false"
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-alert>
        <!--SHIPPED PACKING LISTS REPORT-->
        <v-dialog
            v-model="reportDialog"
            max-width="520"
            persistent
            :retain-focus="false"
        >
            <v-card :loading="reportLoading">
                <v-card-title class="text-h6">
                    Shipped Packing Lists Report
                </v-card-title>
                <v-card-text>
                    <v-row align="center" class="mb-1">
                        <v-col cols="1">
                            <v-icon color="primary"
                                >mdi-information-outline</v-icon
                            >
                        </v-col>
                        <v-col cols="11">
                            <p class="my-0 body-2">
                                This report will generate an XLS file containing
                                all packing lists with status
                                <strong>shipped and completed</strong>
                                in the selected date range. Some row in the file
                                will be an item of a packing list.
                            </p>
                        </v-col>
                    </v-row>
                    <v-menu
                        ref="reportMenu"
                        v-model="reportMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="reportDateRangeText"
                                label="Select date range"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :rules="[v => !!v || 'Date range is required']"
                                dense
                                outlined
                                class="mt-3"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="reportDates"
                            range
                            scrollable
                            :max="today"
                            close-on-select
                            :max-date="today"
                        >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="secondary"
                                @click="reportMenu = false"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                :disabled="
                                    !reportDates || reportDates.length < 2
                                "
                                @click="reportMenu = false"
                            >
                                OK
                            </v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="secondary"
                        :disabled="reportLoading"
                        @click="closeReportDialog"
                    >
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        :disabled="
                            reportLoading ||
                                !reportDates ||
                                reportDates.length < 2
                        "
                        :loading="reportLoading"
                        @click="generateShippedPackingListsReport"
                    >
                        Generate
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--PROCESS PACKING ORDER-->
        <v-dialog
            v-model="processPackingList"
            :retain-focus="false"
            persistent
            fullscreen
        >
            <ProcessPackingCompleted
                v-if="processPackingList && selectedOrder.status == 'completed'"
                :originalOrder="selectedOrder"
                :project="selectedProject"
                @replacePackingList="replacePackingList"
                @close="closeProcessPackingList"
            />
        </v-dialog>
    </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import API from '@/services/api'
import { mapMutations } from 'vuex'
import {
    FILTER_DEBOUNCE_MS,
    decoratePackingList,
    indexById,
    normalizeFilter,
    projectRecord,
} from '@/utils/packingListBoard'

import * as XLSX from 'xlsx/xlsx.mjs'

export default {
    name: 'CompletedPacking',
    components: {
        ProcessPackingCompleted: () =>
            import('@/components/Packing/ProcessPackingCompleted.vue'),
    },
    props: {
        project: {
            type: Object,
            default: () => ({}),
        },
    },
    data: () => ({
        projects: [],
        selectedProject: {},
        selectedOrder: undefined,
        processPackingList: false,
        projectToFilter: undefined,
        workOrderAndBomToFilter: undefined,
        remissionToFilter: undefined,
        containerToFilter: undefined,
        notesToFilter: undefined,
        requestedShipmentDateToFilter: undefined,
        scheduledForToFilter: undefined,
        createdOnToFilter: undefined,
        shippedOnToFilter: undefined,
        shippedByToFilter: undefined,
        completedOnToFilter: undefined,
        userToFilter: undefined,
        statusToFilter: 'completed',
        loading: false,
        activateAlert: false,
        alertMessage: undefined,
        search: null,
        headers: [
            {
                text: 'ORDER',
                value: 'code',
                align: 'center',
                sortable: false,
            },
            {
                text: 'REMISSION',
                value: 'remission',
                align: 'center',
                sortable: false,
            },
            {
                text: 'PROJECT',
                value: 'project',
                align: 'center',
                sortable: false,
            },
            {
                text: 'WOS - BOMS',
                value: 'workOrdersAndBoms',
                align: 'center',
                sortable: false,
            },
            {
                text: 'CONTAINER',
                value: 'container',
                align: 'center',
                sortable: false,
            },
            {
                text: 'CREATED BY',
                value: 'createdBy',
                align: 'center',
                sortable: false,
            },
            {
                text: 'CREATED ON',
                value: 'createdOn',
                align: 'center',
                sortable: false,
            },
            {
                text: 'REQUESTED SHIPMENT DATE',
                value: 'requestedShipmentDate',
                align: 'center',
                sortable: false,
            },
            {
                text: 'SCHEDULED FOR',
                value: 'scheduledFor',
                align: 'center',
                sortable: false,
                width: 110,
            },
            {
                text: 'SHIPPED ON',
                value: 'shippedOn',
                align: 'center',
                sortable: false,
                width: 110,
            },
            {
                text: 'SHIPPED BY',
                value: 'shippedBy',
                align: 'center',
                sortable: false,
                width: 110,
            },
            {
                text: 'COMPLETED ON',
                value: 'completedOn',
                align: 'center',
                sortable: false,
                width: 110,
            },
            {
                text: 'NOTES',
                value: 'notes',
                align: 'center',
                sortable: false,
            },
            {
                text: 'NET MASS',
                value: 'netMass',
                align: 'right',
                sortable: false,
            },
            {
                text: 'GROSS MASS',
                value: 'grossMass',
                align: 'right',
                sortable: false,
            },

            {
                text: 'ACTIONS',
                value: 'actions',
                align: 'center',
                sortable: false,
            },
        ],
        statusColor: {
            inProgress: '#9E9FA0',
            pending: '#FF9800',
            referred: 'primary',
            scheduled: '#25539d',
            rejected: 'red',
            completed: 'black',
            shipped: '#27BC4F',
        },
        packingLists: [],
        users: [],
        usersById: {},
        projectsById: {},
        itemsPerPage: 50,
        appliedFilters: {
            search: '',
            workOrderAndBom: '',
            user: '',
            remission: '',
            container: '',
            shippedBy: '',
            notes: '',
            requestedShipmentDate: '',
            createdOn: '',
            scheduledFor: '',
            shippedOn: '',
            completedOn: '',
            project: '',
        },
        menu: false,
        dates: [],
        reportDialog: false,
        reportMenu: false,
        reportDates: [],
        reportLoading: false,
        today: new Date().toISOString().split('T')[0],
    }),
    computed: {
        packingListsFiltered() {
            let conditions = []
            if (this.appliedFilters.search) {
                conditions.push(this.filterOrder)
            }
            if (this.appliedFilters.workOrderAndBom) {
                conditions.push(this.filterWorkOrder)
            }
            if (this.appliedFilters.project) {
                conditions.push(this.filterProject)
            }

            if (this.appliedFilters.user) {
                conditions.push(this.filterByUser)
            }

            if (this.appliedFilters.remission) {
                conditions.push(this.filterByRemission)
            }

            if (this.appliedFilters.container) {
                conditions.push(this.filterByContainer)
            }

            if (this.appliedFilters.shippedBy) {
                conditions.push(this.filterByShippedBy)
            }

            if (this.statusToFilter) {
                conditions.push(this.filterByStatus)
            }
            if (this.appliedFilters.notes) {
                conditions.push(this.filterByNotes)
            }
            if (this.appliedFilters.requestedShipmentDate) {
                conditions.push(this.filterByRequestedShipmentDate)
            }
            if (this.appliedFilters.createdOn) {
                conditions.push(this.filterByCreatedOn)
            }
            if (this.appliedFilters.scheduledFor) {
                conditions.push(this.filterByScheduledFor)
            }
            if (this.appliedFilters.shippedOn) {
                conditions.push(this.filterByShippedOn)
            }
            if (this.appliedFilters.completedOn) {
                conditions.push(this.filterByCompletedOn)
            }
            return this.packingLists.filter(order =>
                conditions.every(condition => condition(order))
            )
        },
        dateRangeText() {
            if (!this.dates || this.dates.length < 2) return ''
            return `${this.dates[0]} al ${this.dates[1]}`
        },
        reportDateRangeText() {
            if (!this.reportDates || this.reportDates.length < 2) return ''
            const sorted = [...this.reportDates].sort()
            return `${sorted[0]} ~ ${sorted[1]}`
        },
    },
    watch: {
        search: 'queueFilters',
        workOrderAndBomToFilter: 'queueFilters',
        userToFilter: 'queueFilters',
        remissionToFilter: 'queueFilters',
        containerToFilter: 'queueFilters',
        shippedByToFilter: 'queueFilters',
        notesToFilter: 'queueFilters',
        requestedShipmentDateToFilter: 'queueFilters',
        createdOnToFilter: 'queueFilters',
        scheduledForToFilter: 'queueFilters',
        shippedOnToFilter: 'queueFilters',
        completedOnToFilter: 'queueFilters',
        projectToFilter: 'queueFilters',
    },
    async mounted() {
        try {
            this.loading = true
            const currentDate = new Date()
            const date1 = new Date(currentDate)
            date1.setMonth(date1.getMonth() - 1)
            date1.setHours(0, 0, 0, 0)
            this.dates[0] = date1.toISOString().split('T')[0]
            this.dates[1] = currentDate.toISOString().split('T')[0]
            const [
                userResponse,
                usersResponse,
                projects,
                packingLists,
            ] = await Promise.all([
                API.getMyInfo(),
                API.getLiteUsers(),
                API.getLiteProjects({
                    all: true,
                    closing: true,
                }),
                API.getPackingLists(this.completedQuery()),
            ])
            this.user = userResponse.data.user
            this.users = usersResponse.data.users
            this.usersById = indexById(this.users)
            this.projects = projects
            this.projectsById = indexById(this.projects)
            this.packingLists = packingLists
            this.packingLists.forEach(pl => {
                this.decorateRow(pl)
            })
            this.sort()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    beforeDestroy() {
        clearTimeout(this._filterTimer)
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        async getPackingLists() {
            try {
                this.loading = true
                this.menu = false
                this.packingLists = []
                this.packingLists = await API.getPackingLists(
                    this.completedQuery()
                )
                this.packingLists.forEach(pl => {
                    this.decorateRow(pl)
                })
                this.sort()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        completedQuery() {
            let date1 = new Date(this.dates[0]).getTime()
            let date2 = new Date(this.dates[1]).getTime()
            if (date1 > date2) {
                date1 = this.dates[1]
                date2 = this.dates[0]
            } else {
                date1 = this.dates[0]
                date2 = this.dates[1]
            }
            return {
                status: 'completed',
                startDate: date1,
                endDate: date2,
            }
        },
        decorateRow(packingList) {
            decoratePackingList(packingList, this.usersById, this.projectsById)
        },
        replacePackingList(packingList) {
            const index = this.packingLists.findIndex(
                p => p.id == packingList.id
            )
            if (index >= 0) {
                this.packingLists.splice(index, 1, {
                    ...this.packingLists[index],
                    ...packingList,
                })
                this.decorateRow(this.packingLists[index])
            }
        },
        openProcessPackingList(item) {
            this.selectedOrder = cloneDeep(item)
            this.selectedProject = cloneDeep(this.findProject(item.projectId))
            this.processPackingList = true
        },
        closeProcessPackingList() {
            this.selectedOrder = null
            this.selectedProject = null
            this.processPackingList = false
        },
        filterOrder(order) {
            return order.code
                .toString()
                .toLowerCase()
                .includes(this.appliedFilters.search)
        },
        filterByUser(order) {
            return (order.createdByName || '')
                .toLowerCase()
                .includes(this.appliedFilters.user)
        },
        filterByShippedBy(order) {
            return (order.shippedByName || '')
                .toLowerCase()
                .includes(this.appliedFilters.shippedBy)
        },
        filterByNotes(order) {
            if (order.notes) {
                return order.notes
                    .toLowerCase()
                    .includes(this.appliedFilters.notes)
            } else {
                return false
            }
        },
        filterWorkOrder(order) {
            return order.selectedWorkOrdersAndBomsString
                .toLowerCase()
                .includes(this.appliedFilters.workOrderAndBom)
        },
        filterProject(order) {
            return (order.projectLabel || '')
                .toLowerCase()
                .includes(this.appliedFilters.project)
        },
        filterByRemission(order) {
            return order.remission
                .toString()
                .toLowerCase()
                .includes(this.appliedFilters.remission)
        },
        filterByContainer(order) {
            return order.container
                .toString()
                .toLowerCase()
                .includes(this.appliedFilters.container)
        },
        filterByStatus(order) {
            return order.status
                .toString()
                .toLowerCase()
                .includes(this.statusToFilter.toLowerCase())
        },
        sort() {
            this.packingLists.sort(
                (a, b) =>
                    (b.createdOn.seconds || b.createdOn._seconds) -
                    (a.createdOn.seconds || a.createdOn._seconds)
            )
        },
        findProject(id) {
            return projectRecord(this.projectsById, id)
        },
        queueFilters() {
            clearTimeout(this._filterTimer)
            this._filterTimer = setTimeout(() => {
                this.appliedFilters = {
                    search: normalizeFilter(this.search),
                    workOrderAndBom: normalizeFilter(
                        this.workOrderAndBomToFilter
                    ),
                    user: normalizeFilter(this.userToFilter),
                    remission: normalizeFilter(this.remissionToFilter),
                    container: normalizeFilter(this.containerToFilter),
                    shippedBy: normalizeFilter(this.shippedByToFilter),
                    notes: normalizeFilter(this.notesToFilter),
                    requestedShipmentDate: normalizeFilter(
                        this.requestedShipmentDateToFilter
                    ),
                    createdOn: normalizeFilter(this.createdOnToFilter),
                    scheduledFor: normalizeFilter(this.scheduledForToFilter),
                    shippedOn: normalizeFilter(this.shippedOnToFilter),
                    completedOn: normalizeFilter(this.completedOnToFilter),
                    project: normalizeFilter(this.projectToFilter),
                }
            }, FILTER_DEBOUNCE_MS)
        },

        filterByCreatedOn(order) {
            return (order.createdOnLabel || '')
                .toLowerCase()
                .includes(this.appliedFilters.createdOn)
        },
        filterByRequestedShipmentDate(order) {
            return (
                order.requestedShipmentDate &&
                order.requestedShipmentDate
                    .toLowerCase()
                    .includes(this.appliedFilters.requestedShipmentDate)
            )
        },
        filterByScheduledFor(order) {
            return (
                order.scheduledFor &&
                order.scheduledFor
                    .toLowerCase()
                    .includes(this.appliedFilters.scheduledFor)
            )
        },
        filterByShippedOn(order) {
            return (order.shippedOnLabel || '')
                .toLowerCase()
                .includes(this.appliedFilters.shippedOn)
        },
        filterByCompletedOn(order) {
            return (order.completedOnLabel || '')
                .toLowerCase()
                .includes(this.appliedFilters.completedOn)
        },
        openReportDialog() {
            this.reportDates = []
            this.reportDialog = true
        },
        closeReportDialog() {
            this.reportDialog = false
            this.reportDates = []
        },
        async generateShippedPackingListsReport() {
            try {
                this.reportLoading = true
                const sorted = [...this.reportDates].sort()
                const startDate = sorted[0]
                const endDate = sorted[1]
                const { report } = await API.getShippedPackingListsReport({
                    startDate,
                    endDate,
                })
                if (!report || report.length === 0) {
                    this.alertMessage =
                        'No shipped packing lists found for the selected date range.'
                    this.activateAlert = true
                    this.closeReportDialog()
                    return
                }
                const headers = [
                    'PL Code',
                    'Created By',
                    'Created On',
                    'Project',
                    'Notes',
                    'BOMs',
                    'Work Orders',
                    'Status',
                    'Container',
                    'Remission',
                    'Requested Shipment Date',
                    'Scheduled For',
                    'Pending On',
                    'In Delivery On',
                    'Shipped On',
                    'Completed On',
                    'Vehicle Plate',
                    'Type',
                    'Parent Code',
                    'Item Code',
                    'Description',
                    'Quantity',
                    'Mass',
                    'Packing Qty',
                    'Packing Mass',
                    'Suggested Qty',
                    'Suggested Mass',
                    'Cost Position',
                    'OC',
                ]
                // Excel date serial: integer = pure UTC arithmetic, no
                // timezone ever touches this number when writing/reading XLSX.
                // 'YYYY-MM-DD HH:mm:ss' → parsed as UTC, Colombia offset
                //   (UTC-5) applied → date extracted → integer serial.
                // 'YYYY-MM-DD'           → parsed as UTC date → integer serial.
                const EXCEL_EPOCH_MS = Date.UTC(1899, 11, 30)
                const COLOMBIA_OFFSET_MS = 5 * 60 * 60 * 1000
                const d = dateTimeStr => {
                    if (!dateTimeStr) return ''
                    const str = String(dateTimeStr)
                    const [datePart, timePart] = str.split(' ')
                    const parts = datePart.split('-').map(Number)
                    if (parts.length !== 3) return ''
                    const [y, mo, dy] = parts
                    let dateOnlyMs
                    if (timePart) {
                        const [hh = 0, mm = 0, ss = 0] = timePart
                            .split(':')
                            .map(Number)
                        // Parse as UTC, subtract Colombia offset → local date
                        const localMs =
                            Date.UTC(y, mo - 1, dy, hh, mm, ss) -
                            COLOMBIA_OFFSET_MS
                        const local = new Date(localMs)
                        dateOnlyMs = Date.UTC(
                            local.getUTCFullYear(),
                            local.getUTCMonth(),
                            local.getUTCDate()
                        )
                    } else {
                        dateOnlyMs = Date.UTC(y, mo - 1, dy)
                    }
                    const serial = (dateOnlyMs - EXCEL_EPOCH_MS) / 86400000
                    return isNaN(serial) ? '' : serial
                }
                const DATE_COL_INDICES = [2, 10, 11, 12, 13, 14, 15]
                const rows = [headers]
                for (const pl of report) {
                    const items = pl.items || []
                    for (const item of items) {
                        rows.push([
                            pl.code || '',
                            pl.createdBy || '',
                            d(pl.createdOn),
                            pl.project || '',
                            pl.notes || '',
                            pl.selectedBOMs || '',
                            pl.selectedWorkOrders || '',
                            pl.status || '',
                            pl.container || '',
                            pl.remission || '',
                            d(pl.requestedShipmentDate),
                            d(pl.scheduledFor),
                            d(pl.pendingOn),
                            d(pl.inDeliveryOn),
                            d(pl.shippedOn),
                            d(pl.completedOn),
                            pl.vehiclePlate || '',
                            item.type || '',
                            item.parentCode || '',
                            item.itemCode || '',
                            item.description || '',
                            item.quantity != null ? item.quantity : '',
                            item.mass != null ? item.mass : '',
                            item.packingQty != null ? item.packingQty : '',
                            item.packingMass != null ? item.packingMass : '',
                            item.suggestedQty != null ? item.suggestedQty : '',
                            item.suggestedMass != null
                                ? item.suggestedMass
                                : '',
                            item.costPosition || '',
                            item.oc || '',
                        ])
                    }
                }
                const ws = XLSX.utils.aoa_to_sheet(rows)
                // Apply DD/MM/YYYY format to every date cell (skip header row)
                const numDataRows = rows.length - 1
                DATE_COL_INDICES.forEach(colIdx => {
                    for (let r = 1; r <= numDataRows; r++) {
                        const ref = XLSX.utils.encode_cell({ r, c: colIdx })
                        if (ws[ref] && ws[ref].v !== '') {
                            ws[ref].t = 'n'
                            ws[ref].z = 'DD/MM/YYYY'
                        }
                    }
                })
                ws['!cols'] = headers.map(() => ({ wch: 18 }))
                const wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, ws, 'Shipped PLs')
                XLSX.writeFile(
                    wb,
                    `SHIPPED-PACKING-LISTS-${startDate}_${endDate}.xlsx`
                )
                this.closeReportDialog()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.reportLoading = false
            }
        },
    },
}
</script>

<style>
.v-input .v-label {
    font-size: 12px;
}
.v-data-table-header th {
    background-color: #eeeeee !important;
}
.v-data-table__wrapper {
    max-height: 72vh;
    overflow-y: auto;
}
.v-data-table__row {
    height: 64px;
}
.v-data-table__wrapper thead tr {
    position: sticky;
    top: 0;
    z-index: 10;
}
thead {
    position: sticky;
    z-index: 1;
}
</style>
